<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2026-01-09 15:51:14
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import Form from './form';
import DifferentFormTable from './form/DifferentFormTable.vue';

export default {
  extends: TablePage,
  components: {
    Form,
    DifferentFormTable,
  },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    setColumn(col) {
      const rowData = col;
      if (rowData.field === 'fileOssUrl') {
        rowData.type = 'html';
        rowData.formatter = ({ row }) => `${row.fileOssUrl ? `<a href=${row.fileOssUrl}>${row.fileOssUrl}</a>` : ''}`;
      }
      // if (rowData.field === 'headPhotoIdCardPath') {
      //   rowData.cellRender = { name: 'AdsImage' };
      // }
      return rowData;
    },
    modalClick({ val, row }) {
      if (val.code === 'reconciliation') {
        this.formName = 'Form';
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row,
        };
        this.modalConfig.title = '对账';
        this.openModal();
      }
      if (val.code === 'view_differences') {
        this.formName = 'DifferentFormTable';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看差异项';
        this.openFull();
      }
    },
  },
};
</script>
